import type { BuildOrganizationServiceInstancePathParams } from '../types';
import buildOrganizationServicesCollectionPath from './buildOrganizationServicesCollectionPath';

const buildOrganizationServiceInstancePath = ({
    organizationId,
    instanceId,
}: BuildOrganizationServiceInstancePathParams): string =>
    `${buildOrganizationServicesCollectionPath({ organizationId })}/${encodeURIComponent(
        instanceId
    )}`;

export default buildOrganizationServiceInstancePath;
